<!-- vertical-layout -->
@if (coreConfig.layout.type === 'vertical') {
  <xbaht-vertical-layout></xbaht-vertical-layout>
}
<!-- / vertical-layout -->

<!-- horizontal-layout -->
@if (coreConfig.layout.type === 'horizontal') {
  <xbaht-horizontal-layout></xbaht-horizontal-layout>
}
<!-- / horizontal-layout -->

<!-- theme customizer -->
@if (coreConfig.layout.customizer) {
  <xbaht-core-sidebar name="themeCustomizer" class="customizer d-none d-md-block" [overlayVisibility]="true"
    >
    <a class="customizer-toggle d-flex align-items-center justify-content-center"
      (click)="toggleSidebar('themeCustomizer')">
      <span [data-feather]="'settings'" [class]="'spinner'"></span>
    </a>
    <xbaht-core-theme-customizer></xbaht-core-theme-customizer>
  </xbaht-core-sidebar>
}
<!-- / theme customizer -->
